import React, { ReactNode, useState } from "react"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
import { Currencies } from "@kiwicom/nitro/lib/records/Currency"
import { Session } from "@kiwicom/nitro/lib/records/Session"
import { Provider as SessionProvider } from "@kiwicom/nitro/lib/services/session/context"
import { CurrencyProvider } from "@kiwicom/nitro/lib/services/currency/context"
import { IntlRaw } from "@kiwicom/nitro/lib/records/Intl"
import { useIntlNitro, IntlNitroProvider } from "../../NitroTranslate/services/context"
import { IntlProvider } from "@kiwicom/nitro/lib/services/intl/context"
import { locales } from "../../NitroTranslate/services/dateFns"
import { Locale } from "date-fns"

// currency
import { getCurrency, getOptions } from "../../services/options/reducer"
import { setCurrency } from "../../services/options/actions"
import {
  getRecommendedCurrenciesSelectorJS,
  newCurrencies,
} from "../../services/currencies/selectors"

type TranslationTogglerProps = {
  show: boolean
}

const TranslationToggler = ({ show }: TranslationTogglerProps) => {
  const { onDebug } = useIntlNitro()

  // When the component rerenders, we compare the value of `show`
  // with its cached value, `showCached`, to determine whether to
  // toggle showing translation keys.
  const [showCached, setShowCached] = useState(show)

  if (show !== showCached) {
    onDebug() // Toggles showing translation keys.

    setShowCached(show)
  }

  return null
}

type OwnProps = {
  children: ReactNode
  intl: IntlRaw
  session: Session
}

type Props = OwnProps & {
  // intl
  show: boolean
  // currency
  currencyId: string
  available: Currencies
  recommended: string[]
  onChange: (value: string) => void
  // modals
}

const NitroBridge = ({
  children,

  // intl
  intl,

  show,

  // currency
  currencyId,

  available,
  recommended,
  onChange,

  // session
  session,
}: Props) => {
  // @ts-expect-error: Flow to TS migration.
  const dateFnsLocale = locales[intl.language.id] ?? "en-US"
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const locale: Promise<Locale> = import(`date-fns/locale/${dateFnsLocale}/index.js`)

  return (
    <SessionProvider value={session}>
      <CurrencyProvider
        value={{
          currency: available[currencyId],
          available,
          recommended: recommended.map((code) => available[code]),
          onChange,
        }}
      >
        {/*
        We are mounting both Nitro's IntlProvider and our custom IntlProvider (IntlNitroProvider) here.
        Nitro's IntlProvider is mounted to ensure compatibility with components that still depend on it to
        get language info (e.g. Navbar). Our custom "Nitro's" IntlProvider is used to support deprecated
        Translate components which were moved from Nitro to this repo.
        */}
        <IntlProvider intl={intl}>
          <IntlNitroProvider intl={intl} locale={locale}>
            <TranslationToggler show={show} />
            {children}
          </IntlNitroProvider>
        </IntlProvider>
      </CurrencyProvider>
    </SessionProvider>
  )
}

const connector: Connector<OwnProps, Props> = connect(
  (state) => ({
    // intl
    show: getOptions(state).showTranslationKeys,
    // currency
    currencyId: getCurrency(state),
    available: newCurrencies(state),
    // @ts-expect-error: Flow to TS migration.
    recommended: getRecommendedCurrenciesSelectorJS(state),
  }),
  (dispatch) => ({
    // currency
    // @ts-expect-error: Flow to TS migration.
    onChange: (curr) => dispatch(setCurrency(curr)),
  }),
)

export default connector(NitroBridge)
